import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import EventCard from '../components/EventCard';
import LocationDisplay from '../components/LocationDisplay';
import './SportsPage.css';

interface Event { id: string; slug: string; title: string; short_description: string; category: string; age_min: number; age_max: number; venue_name: string; city: string; start_date: string; is_free: boolean; price_description?: string; rating_avg?: number; rating_count?: number; }

const SportsPage: React.FC = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => { fetchSportsEvents(); }, []);

  const fetchSportsEvents = async () => {
    try {
      setLoading(true); setError(null);
      const today = new Date().toISOString().split('T')[0];
      let query = supabase
        .from('events')
        .select('*')
        .eq('status', 'approved')
        .in('category', ['Sports', 'Sports & Activities'])
        .gte('start_date', today)
        .or(`end_date.is.null,end_date.gte.${today}`);
      const selectedCity = localStorage.getItem('selectedCity');
      if (selectedCity) query = query.eq('city', selectedCity);
      const { data, error } = await query.order('start_date', { ascending: true });
      if (error) throw error;
      setEvents(data || []);
    } catch (err: any) { setError(err.message || 'Failed to load sports events'); } finally { setLoading(false); }
  };

  if (loading) return <div className="sports-container"><div className="loading"><div className="spinner"></div><p>Loading sports activities...</p></div></div>;
  if (error) return <div className="sports-container"><div className="error"><p>😕 Oops! {error}</p><button onClick={fetchSportsEvents} className="retry-btn">Try Again</button></div></div>;

  return (
    <div className="sports-container">
      <button className="back-button" onClick={() => navigate('/')}>← Back to Home</button>
      <LocationDisplay />
      <div className="sports-header"><h1>⚽ Sports & Activities</h1><p>Training, teams, and active programs for kids</p></div>
      {events.length === 0 ? <div className="no-events"><p>🏃 No sports activities found. Check back soon!</p></div> : <div className="sports-list">{events.map(event => <EventCard key={event.id} event={event} />)}</div>}
    </div>
  );
};

export default SportsPage;
